@if (payload$ | async; as p) {
<div class="overlay">
  <div class="content">

    <!-- Identity: logo or org name -->
    <div class="identity">
      @if (p.logoUrl) {
      <img class="logo" [src]="p.logoUrl" [alt]="p.title" />
      } @else {
      <span class="title">{{ p.title }}</span>
      }
    </div>

    <!-- Optional contextual details (e.g. group, subject) -->
    @if (p.subtitle || p.lines?.length || p.qualBadge) {
    <div class="details">
      @if (p.subtitle) {
      <p class="subtitle">{{ p.subtitle }}</p>
      }
      @if (p.qualBadge || p.lines?.length) {
      <div class="meta">
        @if (p.lines?.[0]) {
        <span class="meta-line">{{ p.lines[0] }}</span>
        }
        @if (p.qualBadge) {
        <span class="qual-badge" [style.background]="p.primaryColor ?? '#AC1600'">{{ p.qualBadge }}</span>
        }
      </div>
      }
      @for (line of (p.lines ?? []).slice(1); track line) {
      <p class="meta-extra">{{ line }}</p>
      }
    </div>
    }

    <!-- Branded loading dots -->
    <div class="dots">
      <div class="dot" [style.background]="p.primaryColor ?? '#AC1600'"></div>
      <div class="dot" [style.background]="p.primaryColor ?? '#AC1600'"></div>
      <div class="dot" [style.background]="p.primaryColor ?? '#AC1600'"></div>
    </div>

  </div>
</div>
}
